import Vue from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import mdiVue from 'mdi-vue/v2'
import * as mdijs from '@mdi/js'

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faUserGroup } from '@fortawesome/free-solid-svg-icons'   //pour la liste des icônes disponibles aller https://fontawesome.com/search?o=r&m=free
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'   //pour la liste des icônes disponibles aller https://fontawesome.com/search?o=r&m=free
import { faChartColumn } from '@fortawesome/free-solid-svg-icons'   //pour la liste des icônes disponibles aller https://fontawesome.com/search?o=r&m=free
/* add icons to the library */
library.add(faUserGroup,faCircleQuestion,faChartColumn)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import router from "./router/index";
import store from "./store/index";

import NbInvitation from "./components/Role/NbInvitationCounter.vue";

import VueApexCharts from 'vue-apexcharts'
/*
const token = sessionStorage.getItem('user-token')
if (token) {
    axios.defaults.headers.common['Authorization'] = token
} */

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);

Vue.component('Nb-Invitation',NbInvitation);



Vue.config.productionTip = true;

const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
})

Vue.use(mdiVue, {
  icons: mdijs
}) 


Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts)

new Vue({
    router,
    store,
  //  vuetify,
    render: h => h(App)
}).$mount("#app");


